import { BOOLEAN_SELECT_LIST_ITEMS, Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  StaffServiceTypeFilter as StaffServiceTypeFilterModel,
  StaffServiceTypeFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StaffServiceTypeFilter = (props: {
  filter: StaffServiceTypeFilterModel;
  setFilter: (value: StaffServiceTypeFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StaffServiceTypeFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.staffServiceTypes.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolField = () => {
    const propertyName = pn<StaffServiceTypeFilterModel>("schoolId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.schools?.find((x) => x.id === props.filter.schoolId)}
        options={resource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolId = value?.id;
            })
          )
        }
      />
    );
  };

  const inactiveField = () => {
    const propertyName = pn<StaffServiceTypeFilterModel>("inactive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS?.find((x) => x.id === props.filter.inactive)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.inactive = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {schoolField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {inactiveField()}
      </Grid>
    </Grid>
  );
};
